<template>
  <div ref="printContent" class="print-container">
    <div class="print-content">
      <Watermark />
      <section
        dir="rtl"
        style="
          font-size: 18px;
          font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
          background-color: transparent;
        "
        class="font-modify m-5"
      >
        <h1
          class="text-center text-dark mb-2"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 10px;
          "
        >
          {{ $brand.nameArShort }}
        </h1>
        <h4
          class="text-center text-dark"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 10px;
          "
        >
          تعهد / خروج من المستشفى
        </h4>
        <div
          class="mx-2 text-dark mt-2"
          dir="rtl"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 15px;
          "
        >
          <p
            style="
              background-color: transparent;
              line-height: 2;
              text-align: right;
              font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            "
          >
            اني المريض
            <span style="text-decoration: underline">
              {{ patientSurgeryData.patient_card.patient.name }}
            </span>
            اصر على الخروج من المستشفى رغم نصح الاطباء وكادر المستشفى وبذلهم كل
            المحاولات لاقناعي بالبقاء في المستشفى وحسب ما تقتضيه حالتي الصحية
            اخلي المسؤولية الاطباء والمستشفى من المضاعافات الناجمة عن خروجي من
            المستشفى وذلك بتاريخ (تعليمات وزارة الصحة كتاب رقم 10700 في
            2008/8/17).
          </p>
          <div
            class="my-5 d-flex justify-content-between mx-4"
            style="background-color: transparent; padding: 10px"
          >
            <section>
              <p
                style="
                  font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                  background-color: transparent;
                "
              >
                المريض او ذويه
              </p>
            </section>
            <section>
              <p
                style="
                  font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                  background-color: transparent;
                "
              >
                مسؤول الردهة
              </p>
            </section>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Watermark from "@/components/common/Watermark.vue";

export default {
  name: "PatientDischargeAgainstAdvicePrint",
  components: {
    Watermark,
  },
  props: {
    patientSurgeryData: {
      type: Object,
      required: true,
    },
    surgeryName: {
      type: String,
      default: "",
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async print(surgeryName = "") {
      // Use provided surgeryName or prop (parameter kept for future use if needed)
      // const finalSurgeryName = surgeryName || this.surgeryName
      const printWindow = window.open("", "_blank");
      const { printContent } = this.$refs;

      // Get watermark image source
      const watermarkImg = printContent.querySelector(".watermark-image");
      const watermarkSrc = watermarkImg ? watermarkImg.src : "";

      // Clone the content and update image sources
      const contentClone = printContent.cloneNode(true);
      const watermarkClone = contentClone.querySelector(".watermark-image");
      if (watermarkClone && watermarkSrc) {
        watermarkClone.src = watermarkSrc;
      }

      printWindow.document.write(`
        <!DOCTYPE html>
        <html dir="rtl">
          <head>
            <title>Patient Discharge Against Advice</title>
            <style>
              @page {
                size: A4;
                margin: 20mm;
              }
              body {
                font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                margin: 0;
                padding: 0;
                direction: rtl;
                background-color: transparent;
              }
              .print-content {
                position: relative;
              }
              .print-content > section,
              .print-content > div:not(.watermark-wrapper) {
                position: relative;
                z-index: 10 !important;
                background-color: transparent !important;
              }
              .print-content h1,
              .print-content h4 {
                position: relative;
                z-index: 10 !important;
                text-align: center !important;
                background-color: transparent !important;
              }
              .print-content p,
              .print-content span,
              .print-content div,
              .print-content hr,
              .print-content section {
                position: relative;
                z-index: 10 !important;
                background-color: transparent !important;
              }
              .watermark-wrapper {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 0 !important;
                pointer-events: none;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .watermark-image {
                opacity: 0.2;
                max-width: 400px;
                max-height: 400px;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            </style>
          </head>
          <body>
            ${contentClone.innerHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    },
  },
};
</script>

<style scoped lang="scss">
.print-container {
  display: none;
}

@media print {
  .print-container {
    display: block;
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .print-content {
    position: relative;
    z-index: 1;
  }

  .print-content > section,
  .print-content > div:not(.watermark-wrapper),
  .print-content > h1,
  .print-content > h4,
  .print-content > p {
    position: relative;
    z-index: 10 !important;
    background: transparent;
  }

  .font-modify {
    letter-spacing: normal !important;
  }

  @page {
    size: A4;
    margin: 20mm;
  }
}
</style>
